// Initialisation des variables globales pour le navigateur
window.entreprise = localStorage.getItem('entreprise') || null;
window.token = localStorage.getItem('token') || null;
window.API_URL = process.env.REACT_APP_API_URL || 'https://api.niralakka.fr';
